import { useState } from 'react';
import '../../../hooks/index.js';
import { useMenuContext } from '../MenuContext.js';
import { useDidUpdate } from '../../../hooks/useDidUpdate/useDidUpdate.js';

/*
    this hook returns a method that
        1. Scrolls to the top or bottom boundary of a virtual list
        2. waits until the `visibleChildren` prop has updated completely
        3. Uses `visibleChildren`'s ref to focus.
*/
const useFocusVirtualBoundary = function (visibleChildren) {
  let backButtonRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  const [scrollComplete, setScrollComplete] = useState(null);
  const {
    virtuoso
  } = useMenuContext();
  useDidUpdate(() => {
    window.requestAnimationFrame(() => {
      if (scrollComplete && visibleChildren[visibleChildren.length - 1].element.current) {
        if (scrollComplete === 'top' && backButtonRef !== null && backButtonRef !== void 0 && backButtonRef.current) {
          backButtonRef === null || backButtonRef === void 0 || backButtonRef.current.focus();
        } else {
          var _visibleChildren;
          (_visibleChildren = visibleChildren[scrollComplete === 'bottom' ? visibleChildren.length - 1 : 0]) === null || _visibleChildren === void 0 || (_visibleChildren = _visibleChildren.element) === null || _visibleChildren === void 0 || (_visibleChildren = _visibleChildren.current) === null || _visibleChildren === void 0 || _visibleChildren.focus();
        }
        setScrollComplete(null);
      }
    });
  }, [visibleChildren, scrollComplete]);
  return topOrBottom => {
    var _virtuoso$current;
    (_virtuoso$current = virtuoso.current) === null || _virtuoso$current === void 0 || _virtuoso$current.scrollToIndex({
      index: topOrBottom === 'top' ? 0 : 'LAST',
      behavior: 'auto'
    });
    setScrollComplete(topOrBottom);
  };
};

export { useFocusVirtualBoundary as default };
